import React, { FunctionComponent } from "react";
import { Content } from "@iventis/translations/content/typed-content";
import { TimeSelector } from "@iventis/components";
import { StyledFieldLabel } from "@iventis/styles/src/components/forms";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";

export const TimeSelectorWrapper: FunctionComponent<{
    timeName: "startTime" | "endTime" | "zeroTime" | "relativeTime" | "duration";
    showLabel?: boolean;
    className?: string;
    disabled?: boolean;
    onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
    name?: string;
    value: string;
    onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    helperText?: string;
    error?: boolean;
    style?: React.CSSProperties;
}> = ({ timeName, value, error, onChange, helperText, onBlur, showLabel = true, disabled = false, className, style = {} }) => {
    const translate = useIventisTranslate();
    const label = {
        startTime: translate(Content.schedule.create_session_form.inputLabels.sTime),
        endTime: translate(Content.schedule.create_session_form.inputLabels.eTime),
        zeroTime: translate(Content.schedule.create_session_form.inputLabels.zTime),
        relativeTime: translate(Content.timerules.type.relative_time),
        duration: translate(Content.schedule.create_session_form.inputLabels.duration),
    };
    return (
        <div className={className} style={style}>
            {showLabel && <StyledFieldLabel className={`${timeName}-label`}>{label[timeName]}</StyledFieldLabel>}
            <TimeSelector disabled={disabled} name={timeName} value={value} onChange={onChange} error={!!error} helperText={helperText} onBlur={onBlur} />
        </div>
    );
};
